import { YEARS } from "../../../../constants/options";
import React from "react";
import { DatePart } from "./datePart";

export const DateYear = ({name, year, ariaLabel, handleChange, handleBlur, errors, touched, minYear, maxYear}) => {
  const upcomingYears = maxYear > 0;
  const options = YEARS(Math.abs(minYear), Math.abs(maxYear), upcomingYears);
  return (
    <DatePart
      name={name}
      dayMonthOrYear="year"
      ariaLabel={ariaLabel}
      value={year}
      handleChange={handleChange}
      handleBlur={handleBlur}
      errors={errors}
      touched={touched}
      options={options}
    />
  )
};